import FirstBlogPost from '../posts/sample.md';
import FirstBlogPostImage from '../assets/img/post_1.png'

const Posts = [
    {
        title: "Learn How to Create a Blog With These Simple Steps",
        date: "January 4, 2021",
        description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        image: FirstBlogPostImage,
        content: FirstBlogPost,
        route: "cool-blog-post"
    },
]

export default Posts;